import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import {StandardSemiBoldTypography} from 'patient-ping-remedy/packages/typography';
import Badge from 'patient-ping-remedy/packages/badge';
import TableAccordion from 'patient-ping-remedy/packages/table-accordion';
import {DatePickerWrapper} from '@common/DatePickerWrapper';

export const Wrapper = styled.div`
  display: flex;
  justify-content: end;
  flex: 1;
`;

export const Trigger = styled.button`
  padding: 0;
  background: none;
  border: none;
  white-space: nowrap;
`;

export const FilterWrapper = styled(TableAccordion)`
  margin: 0;
  padding-right: 0;
  border-bottom: 0;
  border-top-color: ${colors.gray3};

  &:first-of-type {
    padding-top: 0;
    border-top: none;
  }

  &:last-of-type {
    padding-bottom: 0;
  }

  & > div:first-of-type {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;

    & > div > div {
      color: ${colors.gray5};
      transform: rotate(0deg);

      &:not(.is-open) {
        transform: rotate(-180deg);
      }
    }

    & > div > span {
      margin: 0;
    }
  }

  & > div:last-child {
    margin: 0;
    padding: ${sizes.small} 0 0;
  }
`;

export const FilterLabel = styled(StandardSemiBoldTypography)`
  display: flex;
  align-items: center;
  gap: ${sizes.xSmall};
  text-transform: uppercase;
  color: ${colors.gray5} !important;

  & > span {
    color: ${colors.white} !important;
  }
`;

export const FilterBadge = styled(Badge)`
  padding: 0.1rem 0.5rem;
`;

export const FilterDropdownMultiGroupSelectWrapper = styled.div`
  & > div > div[class$="container"] {
    margin-top: 0;
  }

  & > div > div:first-of-type,
  & > div > span {
    display: none;
  }
`;

export const FilterDropdownSingleSelectWrapper = styled.div`
  & > div > div[class$="container"] {
    margin-top: 0;
  }
`;

export const FilterDatePickerWrapper = styled(DatePickerWrapper)`
  display: flex;
  gap: ${sizes.small};

  & > div > br,
  & > div > span {
    display: none;
  }
`;
